import CustomersList from "./list";

export default CustomersList;
